import { WISE_ALIAS } from '../../resources/provider-constants';
var FeeType;
(function (FeeType) {
    FeeType["HIDDEN"] = "HIDDEN";
    FeeType["MARKETED"] = "MARKETED";
})(FeeType || (FeeType = {}));
export { FeeType };
function sortWiseFirstThenByProviderAlias(firstQuote, secondQuote) {
    if (isWiseQuote(firstQuote)) {
        return -1;
    }
    if (isWiseQuote(secondQuote)) {
        return 1;
    }
    return firstQuote.provider.alias.localeCompare(secondQuote.provider.alias);
}
export function isWiseQuote(quote) {
    return quote && quote.provider.alias === WISE_ALIAS;
}
export function sortTransferFeeComparisonQuoteByReceiveAmount(quotes) {
    // the use of slice() here is to provide a shallow copy of quotes, otherwise the original array is modified, which could lead to unexpected behaviour
    return quotes.slice().sort((q1, q2) => {
        if (q2.receiveAmount.value === q1.receiveAmount.value) {
            return sortWiseFirstThenByProviderAlias(q1, q2);
        }
        return q2.receiveAmount.value - q1.receiveAmount.value;
    });
}
export function transformV2ToComparisonQuote(quote) {
    return {
        alias: quote.provider.alias,
        name: quote.provider.name,
        logo: quote.provider.logoUrl,
        partner: quote.provider.partner,
        fees: quote.fees.total.value,
        rate: quote.rate,
        receivedAmount: quote.receiveAmount.value,
    };
}
